export const allLanguages = ['Uni', 'Earther', 'Quexish', 'Enneo', 'Yizkez', "Koz'alen", 'Iese', "Ts'ts"];

export const allStatusEffects = [
    'Bleeding', 'Blind', 'Burdened', 'Burned', 'Concussed', 'Crippled - Arm', 'Crippled - Leg', 'Deaf', 'Disguised', 'Disheartened 1', 'Disheartened 2', 'Disheartened 3', 'Frozen','Invisible','Paralyzed', 'Poisoned', 'Prone',
    'Radiated 1', 'Radiated 2', 'Radiated 3','Restrained', 'Stunned', 'Weightless'
];

export const damageTypes = [
    'Acid', 'Blunt', 'Blade', 'Cold', 'Electric', 'Explosive', 'Fire', 'Hypoxic','Laser','Poison', 'Psychic', 'Radiation'
];


// Wiki
export const wikiSections = [
    'Intro/Background', 'Character Creation', 'Character Stats', 'Skills & Perks', 'Inventory, Equipment, Mods, & Crafting', 'Outside of Combat', 'Combat Encounters', 'Exploring Kaleido', 'Appendix'
];

export const introSubSections = [
    'Introduction', 'A Brief History', 'Exploring Kaleido', 'Cooperative Storytelling', 'Actions & Skill Checks'
];

export const charCreationSubSections = [
    'Building a Character', 'Where Are Classes?', 'Choosing a Species', 'Human', 'Cyborg', 'Quexi', 'Aerzha', 'Muhmin', "Ts'tsen", "Veith", "Koz'Aid", 'Bringing Your Character To Life'
];

export const charStatsSubSections = [
    'Attributes', 'Skill Modifiers', 'Initiative', 'Movement', 'Health (HP)', 'DIS & KIN', 'TARG & EVA', 'Carrying Capacity'
];

export const skillSubSections = [
    'What are Skills?', 'Perks & Expertise', 'Builds', 'Armor', 'Assault Weapons', 'Astrobiology', 'Athletics', 'Blade', 'Blunt', 'Energy', 'Espionage', 'Explosives', 'Fluid', 'Gravity', 'Long Range', 'Negotiation', 'Observation', 'Pistol', 'Psyche', 'Tech', 'Unarmed', 'Vehicles', 'Wave'
];

export const equipSubSections = [
    'Inventory', 'Getting New Items', 'Money/Funds', 'Equipment', 'Melee Weapons', 'Guns', 'Modifying Equipment', 'Stackable Items & Consumables'
];

export const outsideCombatSubSections = [
    'General Information', 'Skill Rolls', 'Saving Throws', 'Investigation', 'Global Suspicion', 'Advantage/Disadvantage', 'Working Together', 'Resting'
];

export const combatSubSections = [
    'What is An Encounter?', 'Rolling Initiative', 'Available Actions', 'Movement', 'Major Actions', 'Minor Actions',  'Damage Types & Status Effects', 'Ranged Combat', 'Stim Combat', 'Melee Combat / Engagement', 'Attacks of Opportunity', 'Offhand Attacks', 'Cover & Terrain', 'Action on Reaction'
];

export const kaleidoSubSections = [
    'Exploring The Kaleido Universe', 'Two Galaxies', 'The Spyglass', 'Flying Through Space', 'Travelling Between Systems', 'Species Relationships', 'The IPF', 'Other Key Organizations'
]

export const appendixSubSections = [
    'Perks', 'Crafting Recipes'
]